import { Modal } from '@bp/ui-components';
import { AboutBP } from 'components/AboutBP/AboutBP';
import type { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

export type AboutModalProps = {
  isAdmin?: boolean;
  matrixOnline?: boolean;
  state: boolean;
  setState: Dispatch<SetStateAction<boolean>>;
};

export const AboutModal = ({ isAdmin, state, setState, matrixOnline }: AboutModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal title={t('app.title.full')} isOpen={state} onRequestClose={() => setState(false)}>
      <AboutBP isAdmin={!!isAdmin} matrixOnline={matrixOnline ?? true} />
    </Modal>
  );
};
